import React, { useState, useEffect } from "react";
import "./ErrorNotification.css";
import { useTranslation } from "react-i18next";

const ErrorNotification = ({ errors, width, marginBottom, marginLeft }) => {
  const [showErrors, setShowErrors] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Check if errors object has any error messages
    const hasErrors =
      errors &&
      Object.keys(errors).length > 0 &&
      Object.values(errors).some(
        (error) => typeof error === "string" && error.trim() !== ""
      );

    setShowErrors(hasErrors);
  }, [errors]);

  if (!showErrors) return null;

  const containerStyle = {
    width: width || "auto",
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginBottom !== undefined && { marginBottom }),
  };

  return (
    <div className="error-notification-container" style={containerStyle}>
      <div className="error-list">
        {(() => {
          const renderedItems = [];
          const seenSet = new Set();

          Object.entries(errors).forEach(([field, message]) => {
            if (!message || typeof message !== "string" || message.trim() === "") return;

            let fieldDisplayName = "";
            const lineMatch = field.match(/^(?:product_)?line_(\d+)$/i);
            const cpMatch = field.match(/^contact_person_(\d+)(?:_(.+))?$/i);

            if (lineMatch) {
              fieldDisplayName = `Product Line ${lineMatch[1]}`;
            } else if (cpMatch) {
              const indexNum = cpMatch[1];
              fieldDisplayName = `Contact Person ${indexNum}`;
            } else if (field === "street_1") {
              fieldDisplayName = "Street 1";
            } else if (field === "street_2") {
              fieldDisplayName = "Street 2";
            } else {
              const cleanField = field.replace(/_\d+$/, "").replace(/_id$/i, "");
              fieldDisplayName = cleanField
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())
                .replace(/^Phone$/, "Phone Number")
                .replace(/^(Website|Website Url)$/i, "Website URL")
                .replace(/^License$/i, "License Number")
                .replace("Income Expense Type", "Income/Expense Type")
                .replace(/\bUom\b/gi, "UOM");
            }

            let displayMessage = message;
            if (typeof displayMessage === "string") {
              const cleanMessage = displayMessage.trim().toLowerCase();
              const cleanFieldLabel = fieldDisplayName.trim().toLowerCase();

              if (
                cleanMessage === "is required." ||
                cleanMessage === "is required" ||
                cleanMessage === "this field is required" ||
                cleanMessage === "this field is required." ||
                cleanMessage === `${cleanFieldLabel} is required` ||
                cleanMessage === `${cleanFieldLabel} is required.` ||
                cleanMessage === `${cleanFieldLabel} is required!`
              ) {
                displayMessage = "This field is required.";
              } else {
                const isValidationOrReq = 
                  cleanMessage.includes("required") || 
                  cleanMessage.includes("invalid") || 
                  cleanMessage.includes("exists") || 
                  cleanMessage.includes("must");

                if (!isValidationOrReq) {
                  const regex = new RegExp(`^${fieldDisplayName}\\s*`, "i");
                  displayMessage = displayMessage.replace(regex, "");
                }
              }
              displayMessage = displayMessage.replace(/^contact\s*person\s*\d*\s*/i, "").trim();
              if (displayMessage) {
                displayMessage = displayMessage.charAt(0).toUpperCase() + displayMessage.slice(1);
              }
            }

            const itemKey = `${field === 'form_error' ? 'Form Error' : t(fieldDisplayName)}: ${t(displayMessage)}`;
            if (!seenSet.has(itemKey)) {
              seenSet.add(itemKey);
              renderedItems.push(
                <div key={field} className="error-item">
                  {field !== "form_error" && (
                    <span className="error-field-name">
                      {t(fieldDisplayName)}:
                    </span>
                  )}{" "}
                  <span className="error-message">{t(displayMessage)}</span>
                </div>
              );
            }
          });

          return renderedItems;
        })()}
      </div>
    </div>
  );
};

export default ErrorNotification;
